/* eslint-disable */
import React, { Fragment, useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { Menu, Transition } from '@headlessui/react';
// import { DOMAIN } from '../../config';
import { removeFromStorage } from '../../utils/webStorage';
import { useGetCurrentUserQuery } from '../../store/user/userApi';
import Navigation from './Navigation';
import ThemeToggle from '../../shared/theme-toggle';
import NewChatModal from '../../components/new-chat/NewChatModal';
import Modal from '../../shared/modal';
import { useTheme } from '../../theme-context';
import { PartnerGuard } from '../../guards/RolesGuard';

interface ISidebar {
  onClickShowModal: () => void;
  onClickOpenChat: (id?: string, action?: any) => void;
  isMobile?: boolean
}

const Sidebar = ({
  onClickShowModal,
  onClickOpenChat,
  isMobile = false
}: ISidebar) => {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const [userInfoData, setUserInfoData] = useState<any>();
  const { data: userInfo } = useGetCurrentUserQuery();
  const [search, setSearch] = useState<string>();
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  const performLogout = () => {
    removeFromStorage('accessToken');
    removeFromStorage('refreshToken');
    removeFromStorage('roles');
    removeFromStorage('user');
    window.location.reload();
    navigate('/login');
  };

  const handleSwitchUser = () => {
    removeFromStorage('accessToken');
    removeFromStorage('refreshToken');
    removeFromStorage('roles');
    removeFromStorage('user');
    window.location.href = '/login?switchUser=true';
  };

  const handleLogout = () => {
    setShowLogoutConfirm(true);
  };

  const confirmLogout = () => {
    setShowLogoutConfirm(false);
    performLogout();
  };

  const onChangePageSearch = (value: string) => {
    setSearch(value)
  }

  const isJsonObject = (jsonString: string) => {
    try {
      const o = JSON.parse(jsonString);
      if (o && typeof o === 'object') {
        return true;
      }
    }
    catch (e) { }
    return false;
  };

  const getCurrentUserData = async () => {
    const getUserLocal: any = localStorage.getItem('user') || null;
    const userFormat: any = isJsonObject(getUserLocal) ? JSON.parse(getUserLocal) : undefined
    if (getUserLocal && (!userFormat && !userFormat?.username)) {
      setUserInfoData(getUserLocal)
    } else {
      setUserInfoData(userInfo?.username)
      // localStorage.setItem('user', userInfo?.username || '');
      localStorage.setItem('user', userInfo?.username || '');
    }
  }

  useEffect(() => {
    if (!userInfoData) {
      getCurrentUserData()
    }
  }, [userInfo])

  return (
    <div className={`${isMobile ? 'w-64 h-full flex flex-col bg-white dark:bg-[#2a2a2a]' : 'hidden md:flex md:w-64 md:flex-col md:fixed md:inset-y-0 border-r-1 border-r dark:border-borderColor-darkMode dark:bg-bgColor-darkMode'}`}>
      <div className='flex flex-row items-center justify-between mb-6 mt-4 px-3 sm:px-4'>
        <div className='flex flex-row items-center'>
          <img
            className='w-10 h-10 sm:w-12 sm:h-12 bg-black dark:bg-white rounded-full mr-2'
            src='/assets/profile/user-icon.svg'
            alt='main photo'
          />
          <div className='text-left'>
            <div title={userInfoData} className='text-sm sm:text-base font-normal text-primary-light dark:text-primary-dark truncate max-w-[120px] overflow-hidden whitespace-nowrap'>
              {userInfoData}
            </div>
            <p className='text-xs sm:text-sm text-primary-light dark:text-primary-dark'>{PartnerGuard() ? 'Administrator' : 'Member'}</p>
          </div>
        </div>
        <div className='flex flex-row items-center justify-end'>
          <NavLink className='cursor-pointer hover:opacity-80' to='/settings'>
            <img
              src={theme === 'dark' ? '/assets/navigation-icons/sidebar/settings-icon-white.svg' : '/assets/navigation-icons/sidebar/settings-icon.svg'}
              className='object-contain w-5 h-5 sm:w-[23px] sm:h-[23px] mr-2'
            />
          </NavLink>
          <Menu as='div' className='relative mt-1'>
            <Menu.Button className='cursor-pointer hover:opacity-80'>
              <img
                src={theme === 'dark' ? '/assets/navigation-icons/sidebar/logout-icon-white.svg' : '/assets/navigation-icons/sidebar/logout-icon.svg'}
                className='object-contain w-5 h-5 sm:w-[23px] sm:h-[23px]'
                alt='Account menu'
              />
            </Menu.Button>
            <Transition
              as={Fragment}
              enter='transition ease-out duration-100'
              enterFrom='transform opacity-0 scale-95'
              enterTo='transform opacity-100 scale-100'
              leave='transition ease-in duration-75'
              leaveFrom='transform opacity-100 scale-100'
              leaveTo='transform opacity-0 scale-95'
            >
              <Menu.Items className='absolute right-0 mt-2 w-48 origin-top-right rounded-md bg-white dark:bg-bgColor-darkMode shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none border border-gray-200 dark:border-gray-600 z-50'>
                <div className='py-1'>
                  <Menu.Item>
                    {({ active }) => (
                      <button
                        type='button'
                        onClick={handleSwitchUser}
                        className={`${active ? 'bg-gray-100 dark:bg-gray-700' : ''} block w-full text-left px-4 py-2 text-sm text-primary-light dark:text-primary-dark`}
                      >
                        Switch User
                      </button>
                    )}
                  </Menu.Item>
                  <Menu.Item>
                    {({ active }) => (
                      <button
                        type='button'
                        onClick={handleLogout}
                        className={`${active ? 'bg-gray-100 dark:bg-gray-700' : ''} block w-full text-left px-4 py-2 text-sm text-primary-light dark:text-primary-dark`}
                      >
                        Logout
                      </button>
                    )}
                  </Menu.Item>
                </div>
              </Menu.Items>
            </Transition>
          </Menu>
        </div>
      </div>

      {PartnerGuard() &&
        <div className='border-b py-3 px-3 sm:px-4'>
          <div
            onClick={() => onClickOpenChat(undefined, undefined)}
            className='flex flex-row items-center cursor-pointer hover:opacity-80 px-1 sm:px-2 mb-3'>
            <img
              src={theme === 'dark' ? '/assets/navigation-icons/sidebar/new-question-white.svg' : '/assets/navigation-icons/sidebar/new-question.svg'}
              className='object-contain w-5 h-5 sm:w-[23px] sm:h-[23px] mr-2 sm:mr-3'
            />
            <p className='text-sm sm:text-base dark:text-primary-dark'>Ask Questions</p>
          </div>
          <div
            onClick={onClickShowModal}
            className='flex flex-row !rounded-lg bg-[#FAFAFA] dark:bg-black items-center justify-between p-2 cursor-pointer hover:opacity-80'
          >
            <div className='flex flex-row items-center'>
              <img
                src={theme === 'dark' ? '/assets/navigation-icons/sidebar/search-icon-white.svg' : '/assets/navigation-icons/sidebar/search-icon.svg'}
                className='object-contain w-5 h-5 sm:w-[23px] sm:h-[23px] mr-2 sm:mr-3'
              />
              <p className='text-sm sm:text-base text-primary-light'>Search chats...</p>
            </div>
            <img
              src={theme === 'dark' ? '/assets/navigation-icons/sidebar/text-icon-white.svg' : '/assets/navigation-icons/sidebar/text-icon.svg'}
              className='object-contain w-5 h-5 sm:w-[23px] sm:h-[23px]'
            />
          </div>
        </div>
      }
      <div className='flex flex-col flex-grow pt-2 overflow-y-auto'>
        <nav data-qa='navigation' className='flex-1 px-3 sm:px-4 pb-4'>
          <Navigation search={search} />
        </nav>
      </div>

      <div className='border-t px-3 py-3'>
        {/* <div className='!rounded-lg bg-[#F5F5F5] dark:bg-black border border-[#e9eaeb] p-3 cursor-pointer hover:opacity-80 '>
          <div className='flex flex-row items-center mb-2'>
            <img
              src={theme === 'dark' ? '/assets/navigation-icons/sidebar/add-icon-white.svg' : '/assets/navigation-icons/sidebar/add-icon.svg'}
              className='object-contain w-6 h-6 sm:w-[20px] sm:h-[20px] mr-2'
            />
            <p className='font-semibold text-sm dark:text-primary-dark sm:text-base'>Add agent</p>
          </div>
          <p className='text-xs sm:text-sm dark:text-primary-dark'>Find more about our upcoming agents and deals.</p>
        </div> */}

        <div className='my-4 sm:my-5'>
          <ThemeToggle />
        </div>

        <img
          src={theme === 'dark' ? '/assets/navigation-icons/sidebar/sidebar-icon-white.svg' : '/assets/navigation-icons/sidebar/sidebar-icon.svg'}
          className='object-contain h-10 sm:h-[45px] my-2'
        />
      </div>

      <Modal
        open={showLogoutConfirm}
        onClose={() => setShowLogoutConfirm(false)}
        title='Confirm Logout'
        contentContainerStyle='!rounded-xl min-w-[95%] md:min-w-[400px]'
      >
        <div className='space-y-4'>
          <p className='text-sm text-primary-light dark:text-primary-dark'>
            Are you sure you want to log out? Any unsaved changes may be lost.
          </p>
          <div className='flex justify-end gap-2'>
            <button
              type='button'
              onClick={() => setShowLogoutConfirm(false)}
              className='px-4 py-2 text-sm font-medium rounded-lg border border-gray-300 dark:border-gray-600 text-primary-light dark:text-primary-dark hover:bg-gray-50 dark:hover:bg-gray-700'
            >
              Cancel
            </button>
            <button
              type='button'
              onClick={confirmLogout}
              className='px-4 py-2 text-sm font-medium rounded-lg bg-red-600 text-white hover:bg-red-700'
            >
              Logout
            </button>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default Sidebar;